export const HMSConstants = {
  DEFAULT_SDK_ID: '12345',
};
